<template>
  <main class="content checkout-page">
    <div class="container">
      <div
        v-if="shop && transactionDetails && transactionDetails.qr && !showLoader"
        class="checkout-payment-process"
        style="text-align: center;"
      >
        <p>
          <span style="font-size: 22px;">🛈</span>
          {{ $t('cs.front.scan_qr_using_app_and_wait_up_to_1_min') }}
        </p>

        <img
          :src="transactionDetails.qr"
          alt="QR"
          class="fade-in"
          style="width: 90px;"
        />
        <p>{{ $t('cs.front.payment_token') }}: {{ transactionDetails.token }}</p>
        <p style="color: #be1919"><strong>{{ $t('cs.front.important_note_about_leaving_the_page') }}</strong></p>
        <p v-if="countdown > 0">{{ $t('cs.front.next_payment_status_check') }}: <strong>{{ countdown }}</strong>...</p>
      </div>
    </div>
  </main>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { useRoute } from 'vue-router';
import * as paymentMethodTypes from '../../../consts/payment_method';

export default {
  data() {
    return {
      paymentMethodTypes,
      countdown: 15,
      countdownInterval: null,
      paymentProcessing: false,
    };
  },
  computed: {
    ...mapGetters({
      shop: 'shop/selected',
      transactionDetails: 'transaction/selectedDetails',
      paymentStatus: 'transaction/paymentStatus',
      showLoader: 'showLoader',
    }),
  },
  methods: {
    ...mapActions('transaction', {
      fetchPaymentTransactionDetails: 'fetchTxDetails',
      processPayment: 'processPayment',
    }),
    async checkPayment(txId) {
      if (!txId || this.paymentProcessing) {
        return;
      }

      this.paymentProcessing = true;

      try {
        await this.processPayment(txId);

        if (this.paymentStatus) {
          this.stopChecking();
          this.$router.push({ name: 'checkout.thanks', params: { number: this.paymentStatus.number } });
        }
      } finally {
        this.paymentProcessing = false;
      }
    },
    startChecking(txId) {
      this.countdownInterval = setInterval(() => {
        this.countdown -= 1;

        if (this.countdown === 0) {
          this.countdown = 15;
          this.checkPayment(txId);
        }
      }, 1000);
    },
    stopChecking() {
      if (this.countdownInterval) {
        clearInterval(this.countdownInterval);
        this.countdownInterval = null;
      }
    },
  },
  async mounted() {
    const route = useRoute();
    const { txId } = route.params;

    this.$store.commit('showLoader');

    try {
      if (!txId) {
        return;
      }

      await this.fetchPaymentTransactionDetails(txId);
      await this.checkPayment(txId);

      if (!this.paymentStatus) {
        this.startChecking(txId);
      }
    } finally {
      this.$store.commit('hideLoader');
    }

    this.$store.commit('hideSideCart');
  },
  beforeUnmount() {
    this.stopChecking();
  },
};
</script>
